import { BaseEntity } from "../system";


export enum IntegrationService {
  Telleroo,
  Ebay,
  Shopify,
}

export const IntegrationServiceLookup: Record<IntegrationService, string> = {
  [IntegrationService.Telleroo]: "Telleroo",
  [IntegrationService.Ebay]: "Ebay",
  [IntegrationService.Shopify]: "Shpify",
};

export interface IIntegration extends BaseEntity {
  customerId: string;
  userId: string;
  expiry: string;
  service: IntegrationService;
}